'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeksAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weeksAfter.js
// module id = 752
// module chunks = 0